import "../sass/app.scss";

import anime from "animejs";

document.addEventListener("DOMContentLoaded", function () {
    //////////////////
    //// PREHOME /////
    //////////////////

    let x = 0,
        y = 0,
        strength = 10, // Strength of repulsion
        repulsionZoneRadius = 200,
        attractionZoneRadius = 400,
        friction = 0.8, // Friction helps the letters to stop vibrating
        mobileMaxWidth = 768, // Define the max width for mobile
        mouseMoveHandler = function (e) {
            x = e.pageX;
            y = e.pageY;
        },
        letters = Array.from(
            document.querySelectorAll("#curiositas .letter"),
            (el) => {
                const rect = el.getBoundingClientRect();
                return {
                    el: el,
                    x: rect.left + rect.width / 2 + window.scrollX,
                    y: rect.top + rect.height / 2 + window.scrollY,
                    oy: rect.top + rect.height / 2 + window.scrollY,
                    ox: rect.left + rect.width / 2 + window.scrollX,
                    vy: 0, // velocity in y
                    vx: 0, // velocity in x
                };
            }
        ),
        animate = function () {
            let dx, dy, dist, angle, force;
            let t = Date.now() / 1000; // Current time in seconds
            letters.forEach((letter, i) => {
                dx = x - letter.x;
                dy = y - letter.y;
                dist = Math.sqrt(dx * dx + dy * dy);

                if (window.innerWidth > mobileMaxWidth) {
                    // Desktop behavior
                    if (dist < repulsionZoneRadius) {
                        // in repulsion zone
                        angle = Math.atan2(dy, dx);
                        force = strength / dist;
                        letter.vx -= Math.cos(angle) * force;
                        letter.vy -= Math.sin(angle) * force;
                    } else {
                        // in attraction zone
                        let distToOrigin = Math.sqrt(
                            (letter.x - letter.ox) ** 2 +
                                (letter.y - letter.oy) ** 2
                        );

                        if (distToOrigin > 1) {
                            angle = Math.atan2(
                                letter.oy - letter.y,
                                letter.ox - letter.x
                            );
                            force = 0.05 * distToOrigin; // reducing the attraction force the closer the object gets to its target position
                            letter.vx += Math.cos(angle) * force;
                            letter.vy += Math.sin(angle) * force;
                        }
                    }
                } else {
                    // Mobile behavior
                    letter.vy = Math.sin(t + i) * 0.1;
                }

                letter.vx *= friction; // apply friction to velocity
                letter.vy *= friction; // apply friction to velocity

                letter.x += letter.vx;
                letter.y += letter.vy;

                // Apply transformation
                letter.el.style.transform = `translate(${
                    letter.x - letter.ox
                }px, ${letter.y - letter.oy}px)`;
            });

            window.requestAnimationFrame(animate);
        };

    window.addEventListener("mousemove", mouseMoveHandler);
    animate();

    ///////////////////////////////
    ///// Underline animation /////
    ///////////////////////////////

    let options = {
        root: null, // relative to document viewport
        rootMargin: "0px", // margin around root. Values are similar to css property. Unitless values not allowed
        threshold: 0.1, // visible amount of item shown in relation to root
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add("underlined--start");
                observer.unobserve(entry.target); // to stop observing the current target element
            }
        });
    }, options);

    // Observe all elements with the class "underlined"
    document
        .querySelectorAll(".underlined")
        .forEach((elem) => observer.observe(elem));

    /////////////////////////
    ///// TITLES HACK ///////
    /////////////////////////

    document.fonts.ready.then(function () {
        const elements = Array.from(
            document.querySelectorAll(".event__header__infos h1 p")
        );

        elements.forEach((element) => {
            const words = element.innerText.split(" ");
            let lines = [""];
            let lineIndex = 0;

            const spans = words.map((word, index) => {
                const span = document.createElement("span");
                span.innerText = word + " ";
                return span;
            });

            element.innerHTML = "";
            spans.forEach((span) => element.appendChild(span));

            lines[lineIndex] = spans[0].innerText;

            for (let i = 1; i < spans.length; i++) {
                if (spans[i].offsetTop > spans[i - 1].offsetTop) {
                    lineIndex++;
                    lines[lineIndex] = "";
                }
                lines[lineIndex] += spans[i].innerText;
            }

            // Store the h1 parent
            const parent = element.parentNode;

            // Remove the original p from the h1
            parent.removeChild(element);

            // Add the new p elements directly to the h1
            lines.forEach((line) => {
                const p = document.createElement("p");
                p.innerText = line;
                parent.appendChild(p);
            });
        });
    });

    /////////////////////////
    ///// HOME TEASER ///////
    /////////////////////////

    // Get the cursor and teaser elements
    const cursor = document.querySelector(".edition__teaser__cursor");
    const teaser = document.querySelector(".edition__teaser");
    const video = document.querySelector(".edition__video");

    if (teaser) {
        // On video click
        cursor.addEventListener("click", function () {
            // Play the video
            video.play();

            // Show video controls
            video.controls = true;
            this.setAttribute("style", "opacity:0; pointer-events: none");
        });

        // On teaser mousemove
        teaser.addEventListener("mousemove", function (e) {
            // Calculate the cursor position relative to the teaser element
            const rect = this.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            // Move the cursor element to the cursor position
            cursor.style.left = x + "px";
            cursor.style.top = y + "px";
        });
    }

    /////////////////////////
    ////// INFOS MENU ///////
    /////////////////////////

    // Get all H2 elements
    const h2s = document.getElementsByTagName("h2");

    // Get the menu element
    const menu = document.querySelector(".infos__menu");

    if (menu) {
        // Loop through all H2 elements
        for (let i = 0; i < h2s.length; i++) {
            // Create a new anchor element
            const a = document.createElement("a");

            // Set the href attribute to the H2's id
            a.href = "#" + h2s[i].id;

            // Set the text content to the H2's text content
            a.textContent = h2s[i].textContent;

            // Add the class attributes to the anchor tag
            a.classList.add("infos__menu__link");
            a.classList.add("h5");

            // Append the anchor element to the menu
            menu.appendChild(a);
        }
    }

    /////////////////////////
    ///////// HALO  /////////
    /////////////////////////

    const groups = [
        {
            blocks: document.querySelectorAll(".events__block"),
            blocksBg: document.querySelectorAll(".events__block__bg"),
        },
        {
            blocks: document.querySelectorAll(".infos__places"),
            blocksBg: document.querySelectorAll(".infos__places__bg"),
        },
        {
            blocks: document.querySelectorAll(".archive__block"),
            blocksBg: document.querySelectorAll(".archive__block__img"),
        },
    ];

    function handleMouseAndScrollEvent(e) {
        const eventType = e.type;
        const isMobile = window.innerWidth <= 768;
        let x, y;

        groups.forEach(({ blocks, blocksBg }) => {
            blocks.forEach((block, index) => {
                const rect = block.getBoundingClientRect();

                if (eventType === "mousemove" && !isMobile) {
                    x = e.clientX - rect.left;
                    y = e.clientY - rect.top;
                } else if (eventType === "scroll" && isMobile) {
                    x = rect.width / 2;
                    y = window.innerHeight / 2 - rect.top;
                }

                // If x or y is undefined, set it to 0
                x = x || 1500;
                y = y || 1500;

                blocksBg[index].style.setProperty("--x", x + "px");
                blocksBg[index].style.setProperty("--y", y + "px");
            });
        });
    }

    document.addEventListener("mousemove", handleMouseAndScrollEvent);
    document.addEventListener("scroll", handleMouseAndScrollEvent);

    /////////////////////////
    ///// HOVERING MAP //////
    /////////////////////////

    const departs = document.querySelectorAll(".infos__map__departement");
    const mapLi = document.querySelectorAll(".infos__map__li");
    const circles = document.querySelectorAll(".circle");

    departs.forEach(function (element, index) {
        element.addEventListener("mouseover", function (e) {
            mapLi.forEach(function (element) {
                element.classList.remove("infos__map__li--selected");
            });
            if (index == 7) {
                mapLi[0].classList.add("infos__map__li--selected");
            }
            if (index == 0) {
                mapLi[1].classList.add("infos__map__li--selected");
                mapLi[2].classList.add("infos__map__li--selected");
                mapLi[3].classList.add("infos__map__li--selected");
                mapLi[4].classList.add("infos__map__li--selected");
            }
            if (index == 1) {
                mapLi[6].classList.add("infos__map__li--selected");
                mapLi[7].classList.add("infos__map__li--selected");
                mapLi[8].classList.add("infos__map__li--selected");
                mapLi[9].classList.add("infos__map__li--selected");
                mapLi[10].classList.add("infos__map__li--selected");
                mapLi[11].classList.add("infos__map__li--selected");
                mapLi[12].classList.add("infos__map__li--selected");
                mapLi[13].classList.add("infos__map__li--selected");
                mapLi[14].classList.add("infos__map__li--selected");
            }
            console.log(index);
        });
        element.addEventListener("mouseout", function (e) {
            mapLi.forEach(function (element) {
                element.classList.remove("infos__map__li--selected");
            });
        });
    });

    mapLi.forEach(function (element, index) {
        element.addEventListener("mouseover", function (e) {
            circles.forEach(function (circle, index) {
                circles[index].setAttribute("style", "");
            });
            circles[index].setAttribute("style", "fill:var(--main-color)");
        });
        element.addEventListener("mouseout", function (e) {
            circles.forEach(function (circle, index) {
                circles[index].setAttribute("style", "");
            });
        });
    });

    //////////////////////
    ////// HEADER ////////
    //////////////////////

    let lastScrollTop = 0;
    const header = document.querySelector(".header");
    const prehome = document.querySelector(".prehome");
    const homeTitle = document.querySelector(".home__title");

    if (prehome !== null) {
        header.classList.add("header--home");
    }

    if (window.innerWidth >= 768) {
        window.addEventListener(
            "scroll",
            function () {
                let scrollTop =
                    window.pageYOffset || document.documentElement.scrollTop;
                if (prehome !== null) {
                    if (
                        scrollTop > lastScrollTop &&
                        scrollTop > prehome.offsetHeight + header.offsetHeight
                    ) {
                        if (!header.classList.contains("header--fixed")) {
                            header.classList.add("header--fixed");
                            homeTitle.classList.add("home__title--header");
                        }
                        header.classList.add("header--hidden");
                    } else if (
                        scrollTop > lastScrollTop &&
                        scrollTop > prehome.offsetHeight &&
                        scrollTop < prehome.offsetHeight + header.offsetHeight
                    ) {
                        if (!header.classList.contains("header--fixed")) {
                            header.classList.add("header--fixed");
                            homeTitle.classList.add("home__title--header");
                        }
                    } else if (
                        scrollTop < lastScrollTop &&
                        scrollTop > prehome.offsetHeight + header.offsetHeight
                    ) {
                        // Upscroll
                        header.classList.remove("header--hidden");
                        if (scrollTop <= 0) {
                            header.classList.remove("header--fixed");
                            homeTitle.classList.remove("home__title--header");
                        }
                    } else if (
                        scrollTop < lastScrollTop &&
                        scrollTop < prehome.offsetHeight
                    ) {
                        header.classList.remove("header--fixed");
                        homeTitle.classList.remove("home__title--header");
                    } else if (
                        scrollTop > lastScrollTop &&
                        scrollTop < prehome.offsetHeight
                    ) {
                        homeTitle.classList.remove("home__title--header");
                    }
                } else {
                    if (
                        scrollTop > lastScrollTop &&
                        scrollTop > header.offsetHeight
                    ) {
                        // Downscroll
                        if (!header.classList.contains("header--fixed")) {
                            header.classList.add("header--fixed");
                        }
                        header.classList.add("header--hidden");
                    } else {
                        // Upscroll
                        header.classList.remove("header--hidden");
                        if (scrollTop <= 0) {
                            header.classList.remove("header--fixed");
                        }
                    }
                }
                lastScrollTop = scrollTop;
            },
            false
        );
    }

    /////////////////////////
    ///// PROGRAM LIST //////
    /////////////////////////

    const eventsFilter = document.querySelector(".events__filter__title");
    const eventsFilterArr = document.querySelector(".events__filter__arrow");
    const eventsFilterList = document.querySelector(".events__filter__list");

    if (eventsFilter !== null) {
        eventsFilter.addEventListener("click", function () {
            eventsFilterArr.classList.toggle("events__filter__arrow--open");
            eventsFilterList.classList.toggle("events__filter__list--open");
        });
    }

    document
        .querySelectorAll(".events__filter__place")
        .forEach(function (elem) {
            elem.addEventListener("click", function () {
                const place = this.getAttribute("data-url"); // Get the data-url
                if (place !== "programmation") {
                    console.log(place);
                    window.location.href =
                        window.location.pathname + "?place=" + place; // Update the URL
                } else {
                    window.location.href =
                        window.location.protocol +
                        "//" +
                        window.location.host +
                        "/programmation";
                    console.log("test");
                }
            });
        });

    function filterElements() {
        var urlParams = new URLSearchParams(window.location.search);
        var place = urlParams.get("place");

        if (place !== null) {
            document
                .querySelectorAll(".events__block")
                .forEach(function (elem) {
                    var blockPlace = elem.getAttribute("data-place");
                    if (blockPlace.indexOf(place) === -1) {
                        elem.style.display = "none";
                    } else {
                        elem.style.display = "block";
                    }
                });
        }
    }

    function adjustBorders() {
        // Clear all borders first
        let blocks = document.querySelectorAll(".events__block__container");
        blocks.forEach((block) => {
            block.style.borderLeft = "none";
            block.style.borderRight = "none";
            // block.style.borderBottom = "none"; // Clear bottom border
        });

        // Filter only visible blocks
        let visibleBlocks = Array.from(blocks).filter(
            (block) =>
                window.getComputedStyle(block.parentNode).display !== "none"
        );

        // If viewport width is less than or equal to 768px (typical breakpoint for mobile devices)
        if (window.innerWidth <= 768) {
            // Apply bottom border on visible blocks for mobile
            visibleBlocks.forEach((block) => {
                block.style.borderBottom = "1px solid white";
            });
        } else if (window.innerWidth > 750 && window.innerWidth <= 1150) {
            // Apply right border only to the first block of each row
            visibleBlocks.forEach((block, index) => {
                if (index % 2 === 0) {
                    block.style.borderRight = "1px solid white";
                }
            });
        } else {
            // Apply border rules on visible blocks for desktop
            visibleBlocks.forEach((block, index) => {
                if ((index + 1) % 3 === 2) {
                    block.style.borderLeft = "1px solid white";
                    block.style.borderRight = "1px solid white";
                }

                // For the last block
                if (index === visibleBlocks.length - 1) {
                    block.style.borderRight = "1px solid white";
                }
            });
        }
    }

    window.addEventListener("resize", adjustBorders);

    // Call adjustBorders on page load
    window.onload = adjustBorders;

    window.onload = function () {
        filterElements();
        adjustBorders();
    };

    /////////////////////////
    //////// BURGER  ////////
    /////////////////////////

    const burger = document.querySelector(".header__burger");
    const headerLinks = document.querySelector(".header__links__wrapper");

    burger.addEventListener("click", function () {
        burger.classList.toggle("header__burger--open");
        headerLinks.classList.toggle("header__links__wrapper--open");
    });

    //////////////////////////
    /////// DOUBLE FIX ///////
    //////////////////////////

    function hideElementsByContent(selector, textsToHide) {
        const elements = document.querySelectorAll(selector);
        
        elements.forEach(element => {
            const text = element.textContent.trim();
            
            textsToHide.forEach(item => {
                // Check for the "Université d'Évry" condition
                if (item === "Université d'Évry" && text.includes('Bibliothèque')) {
                    return; // If it contains "-", skip hiding
                }
                if (item === "Université d'Évry" && text.includes('Galerie')) {
                    return; // If it contains "-", skip hiding
                }
                if (item === "Université d'Évry" && text.includes('Parking')) {
                    return; // If it contains "-", skip hiding
                }
    
                if (text.startsWith(item)) {
                    element.style.display = 'none';
                }
            });
        });
    }
    
    const textsToHide = [
        "Université d'Évry",
        "UVSQ - Campus Guyancourt",
        "UVSQ - Campus Versailles"
    ];
    
    hideElementsByContent(".events__block__place__span", textsToHide);
    hideElementsByContent(".event__header__infos__detail__place", textsToHide);
});
